module.exports = __webpack_public_path__ + "static/img/05.264a4fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/05.jpg
// module id = JREj
// module chunks = 0